import React, {FC, useEffect, useState} from 'react';

import path_up from 'assets/images/closeSelectIcon.svg';
import path_down from 'assets/images/openSelectIcon.svg';
import iconStateDisabled from "assets/icons/commons/source-state-disabled.svg"
import iconStateSuccess from "assets/icons/commons/source-state-active.svg"
import iconStateError from "assets/icons/commons/source-state-error.svg"
import ToggleButton from "../ToggleButton";
import {DataSource} from "../../../constants/DataSource/DataSource";
import {DataSourceStatus} from "../../../constants/DataSource/DataSourceStatus";
import {t} from "i18next";
import Input from "../../commons/Input/Input";
import FormSelect, {ISelectOption} from "../../commons/Select/FormSelect";
import {v4 as uuidv4} from "uuid";
import {FrequencySelector} from "../FrequencySelector";

interface DataSourceProps {
  code: string
  data: DataSource|null
  updateDataSourceHandler: (code: string, payload: DataSource|null) => void
  toggleIsDisclosed: (code: string) => void
  toggleItemStatus: (code: string, isActive: boolean) => void
  isDisclosed: boolean
  isActive: boolean
}

export const DmitrovkaResantagroupRu: FC<DataSourceProps> = ({
  code,
  data,
  updateDataSourceHandler,
  toggleIsDisclosed,
  toggleItemStatus,
  isDisclosed,
  isActive
}) => {

  const title = 'Resantagroup.ru - Дмитровка'

  const onStatusChange = (isActiveStatus: boolean) => {
    isActive = isActiveStatus
    toggleItemStatus(code, isActiveStatus)
  };

  // Param - frequency
  const onUpdateFrequencyChange = (frequency: number) => {
    setUpdateFrequency(frequency)
  };
  const [updateFrequency, setUpdateFrequency] = useState(0);
  const [updateFrequencySelectorOptions, setUpdateFrequencySelectorOptions] = useState<ISelectOption[]>([]);
  const [errors, setErrors] = useState({});

  // @ts-ignore
  const fieldsWithErrors = Object.keys(errors).filter((k: string) => errors[k].length > 0)
  const isFormHasErrors = fieldsWithErrors.length > 0
  const state = isActive ? (isFormHasErrors ? 'fail' : 'success') : 'disabled'
  const dataSourceStateIconAssets = {
    'disabled': iconStateDisabled,
    'success': iconStateSuccess,
    'fail': iconStateError
  }

  useEffect(() => {
  }, [data?.status])


  useEffect(() => {
    console.log('useEffect - data', data)
    if (!data) {
      return
    }

    // @ts-ignore
    const updateFrequency = data?.updateFrequency
    setUpdateFrequency(updateFrequency)

  }, [data])

  useEffect(() => {
    console.log('useEffect - updateFrequency, status')

    if (!data && isActive) {
      data = {
        uuid: uuidv4(),
        code: code,
        configMap: {},
        name: title,
        status: isActive ? DataSourceStatus.Current : DataSourceStatus.Archived,
        updateFrequency: 0,
      }
      console.log('Dmitrovka set initial data', data)
    }

    if (data) {
      data.updateFrequency = updateFrequency
      updateDataSourceHandler(code, data)
      console.log('updateDataSourceHandler', data)
    }

    console.log('Dmitrovka data', data)

  }, [updateFrequency, isActive])

  return (
    <div
      className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
    >
      <div className="flex max-h-11 rounded items-center justify-between" onClick={() => toggleIsDisclosed(code)}>
        <div className="flex items-center min-w-36">
          <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">
            <img src={dataSourceStateIconAssets[state]} className="mr-2" />
            {title}
          </div>
        </div>
        <div className="flex items-center">
          <ToggleButton
              label="Подключен"
              labelId="название-опции-тут"
              onChange={onStatusChange}
              isChecked={isActive}
          />
          <div>
            <div>
              <img src={isDisclosed ? path_up : path_down} alt={''} />
            </div>
          </div>
        </div>

      </div>
      {isDisclosed && (
          <div className={'mt-4'}>
            <p className={'text-center text-[#94A3B8] text-[14px] mt-4 mb-3'}>
              Официальный дилер «Ресанта», «Huter», «Вихрь» в г. Москва - Дмитровка
            </p>
            <div className="mt-4">
              <FrequencySelector data={updateFrequency} onChange={onUpdateFrequencyChange}></FrequencySelector>
            </div>

          </div>
      )}
    </div>
  );
};
